import { FaWhatsapp, FaEnvelope, FaPhone, FaTrash } from 'react-icons/fa';
import NewTooltip from '../../../atoms/NewTooltip';
import { ContactDetail, formatActivityDate, getMonthYear } from './useContactPageView';

function getCommunicationIcon(type: string) {
  const icons: Record<string, JSX.Element> = {
    EMAIL: <FaEnvelope className="text-slate-500" />,
    CALL: <FaPhone className="text-slate-500" />,
    WHATSAPP: <FaWhatsapp className="text-slate-500" />,
    email: <FaEnvelope className="text-slate-500" />,
    call: <FaPhone className="text-slate-500" />,
    whatsapp: <FaWhatsapp className="text-slate-500" />,
  };
  return icons[type] || <FaEnvelope className="text-slate-500" />;
}

interface Props {
  contact: ContactDetail;
  onRemove: (id: string) => void;
}

export default function ContactActivityTab({ contact, onRemove }: Props) {
  const interactions = contact.interactions || [];

  const grouped = interactions.reduce((acc, interaction) => {
    const my = getMonthYear(interaction.timestamp);
    if (!acc[my]) acc[my] = [];
    acc[my].push(interaction);
    return acc;
  }, {} as Record<string, typeof interactions>);

  return (
    <div className="space-y-6">
      {Object.entries(grouped).sort((a, b) => new Date(b[1][0].timestamp).getTime() - new Date(a[1][0].timestamp).getTime()).map(([monthYear, items]) => (
        <div key={monthYear}>
          <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4">{monthYear}</h3>
          <div className="space-y-4">
            {items.map((interaction) => (
              <div key={interaction.id} className="group bg-white dark:bg-slate-800 rounded-lg shadow p-4">
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-1">
                      {getCommunicationIcon(interaction.type)}
                      <h4 className="font-medium text-gray-900 dark:text-white">{interaction.description}</h4>
                    </div>
                    {interaction.deals && interaction.deals.length > 0 && (
                      <div className="flex flex-wrap gap-1 mt-1 ml-6">
                        {interaction.deals.map((deal, idx) => (
                          <span key={idx} className="inline-flex items-center px-2 py-0.5 bg-gray-100 dark:bg-slate-700 text-gray-600 dark:text-gray-300 rounded text-xs">
                            {deal.operation} • Nº {deal.dealNumber}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>
                  <div className="flex items-center gap-2 ml-4">
                    {interaction.canRemove && (
                      <NewTooltip content="Remover atividade" alignment="top">
                        <button className="p-1.5 rounded-full text-gray-400 hover:text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20 opacity-0 group-hover:opacity-100 transition-opacity" onClick={() => onRemove(interaction.id)}><FaTrash size={12} /></button>
                      </NewTooltip>
                    )}
                    <span className="text-sm text-gray-500 dark:text-gray-400 whitespace-nowrap">{formatActivityDate(interaction.timestamp)}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
